import { render, staticRenderFns } from "./addRole.vue?vue&type=template&id=084cdacb&scoped=true&"
import script from "./addRole.vue?vue&type=script&lang=ts&"
export * from "./addRole.vue?vue&type=script&lang=ts&"
import style0 from "./addRole.vue?vue&type=style&index=0&id=084cdacb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084cdacb",
  null
  
)

export default component.exports